import React from "react";
import ReactDOM from "react-dom/client";

import "./assets/fonts/Evil-Empire.ttf"
import "./index.css";
import "./i18n";
import reportWebVitals from "./reportWebVitals";

import {
    BrowserRouter,
    // createBrowserRouter,
    Route,
    // RouterProvider,
    Routes,
} from "react-router-dom";
import AppWrapper from "./components/shared/AppWrapper";
import IndexHome from "./pages/home/Index";
import IndexContact from "./pages/contact/Index";
// import IndexRegistration from "./pages/registration/Index.old";
import Faq from "./pages/race-information/Faq";
import CategoryPodium from "./pages/race-information/CategoryPodium";
import RulesRegulation from "./pages/race-information/RulesRegulation";
import Prize from "./pages/race-information/Prize";
import RaceDay from "./pages/race-information/RaceDay";
import RaceResult from "./pages/race-information/RaceResult";
import IndexGallelry from "./pages/gallery/Index";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import Registration from "./pages/registration/Index";
import RedeemVoucher from "./pages/redeem-voucher";
import Invitation from "./pages/invitation";
import Frontliner from "./pages/frontliner";
import RegistrationMenu from "./pages/registration-menu";
import AlternateHome from "./pages/alternate-home";
import Login from "./pages/login/Index";
import Profile from "./pages/profile/Index";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SpecialProgram from "./pages/special-program";
import RegistrationGroup from "./pages/registration-group";
import RegistrationGroupForm from "./pages/registration-group/form";
import RegistrationFrontlinerForm from "./pages/frontliner/form";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <AppWrapper>
                            {/* <RouterProvider router={router} /> */}
                            <Routes>
                                <Route path="/" element={<IndexHome />} />
                                <Route path="/alternate-home" element={<AlternateHome />} />
                                <Route path="/frontliner" element={<Frontliner />} />
                                <Route path="/frontliner/form" element={<RegistrationFrontlinerForm />} />
                                <Route path="/information/faq" element={<Faq />} />
                                <Route path="/information/race-result" element={<RaceResult />} />
                                <Route
                                    path="/information/rules-regulations"
                                    element={<RulesRegulation />}
                                />
                                <Route path="/information/prize" element={<Prize />} />
                                <Route
                                    path="/information/category-podium"
                                    element={<CategoryPodium />}
                                />
                                <Route path="/information/race-day" element={<RaceDay />} />
                                <Route path="/contact-us" element={<IndexContact />} />
                                <Route path="/gallery" element={<IndexGallelry />} />
                                <Route path="/registration" element={<RegistrationMenu />} />
                                <Route path="/special-program" element={<SpecialProgram />} />
                                <Route path="/registration/form" element={<Registration />} />
                                <Route path="/registration-group" element={<RegistrationGroup />} />
                                <Route path="/registration-group/form" element={<RegistrationGroupForm />} />
                                <Route path="/redeem-voucher" element={<RedeemVoucher />} />
                                <Route path="/invitation" element={<Invitation />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/profile" element={<Profile />} />
                            </Routes>
                        </AppWrapper>
                    </BrowserRouter>
                </QueryClientProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
